var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-icon",
    width: 100,
    height: 28,
    viewBox: "0 0 100 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0488 3.47632C15.4626 -1.15877 8.02595 -1.15877 3.43969 3.47632C-1.14656 8.11141 -1.14656 15.6272 3.43969 20.2623L10.6371 27.5363C11.249 28.1548 12.2402 28.1548 12.8522 27.5363L20.0488 20.2623C24.6358 15.6272 24.6358 8.11141 20.0488 3.47632ZM11.8347 22.3145C6.05593 22.3639 1.361 17.6197 1.40987 11.7787C1.45727 6.10788 6.04353 1.47279 11.6545 1.42488C17.4333 1.37549 22.1283 6.11968 22.0794 11.9607C22.0312 17.6315 17.4457 22.2658 11.8347 22.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8374 17.0167C15.8061 18.0591 14.5399 18.7195 13.2103 18.9974C14.0162 18.0458 15.0738 16.3084 12.9324 15.5034C10.179 14.4692 13.9754 13.7092 14.2059 13.6444C14.7558 13.4903 14.7091 13.5058 14.7966 13.4778C15.4312 13.2721 17.2553 12.5298 13.1468 11.5443C8.39718 10.4054 13.8981 9.02254 13.8981 9.02254C13.8981 9.02254 6.78746 9.9985 10.4365 11.273C13.7668 12.4362 12.0841 12.5829 11.7639 12.5998C11.7129 12.6028 11.6618 12.6065 11.6115 12.6116C10.8041 12.6883 5.61246 13.2522 7.61967 14.8798C9.04631 16.0371 7.79034 16.7617 6.75902 17.1229C6.72255 17.0882 6.68681 17.0521 6.65107 17.016C3.83791 14.1729 3.83791 9.56359 6.65107 6.72121C9.46424 3.87809 14.025 3.87809 16.8374 6.72121C19.6513 9.56507 19.6513 14.1744 16.8374 17.0167Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9995 4.17285V22.4001H95.7402V4.17285H99.9995Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1931 9.0113V12.9025C93.5249 12.7318 92.9654 12.6465 92.5144 12.6465C90.3764 12.6465 89.3074 13.8924 89.3074 16.3841V22.4001H85.0732V9.1905H89.1321L89.107 11.4433C89.558 10.5729 90.0925 9.9329 90.7105 9.5233C91.3452 9.09663 92.1386 8.8833 93.0907 8.8833C93.4581 8.8833 93.8256 8.92597 94.1931 9.0113Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3004 4.17285H81.9856V15.1041C81.9856 17.7153 81.3258 19.6438 80.0063 20.8897C78.7034 22.1185 76.7575 22.7329 74.1686 22.7329C71.5295 22.7329 69.5753 22.1185 68.3058 20.8897C67.0531 19.6438 66.4268 17.7153 66.4268 15.1041V4.17285H71.1119V15.2065C71.1119 16.3841 71.3458 17.2801 71.8135 17.8945C72.2978 18.5089 73.1163 18.8161 74.2688 18.8161C76.2898 18.8161 77.3004 17.6129 77.3004 15.2065V4.17285Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3479 4.17285V22.4001H59.0887V4.17285H63.3479Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9343 4.17285V7.44965H51.675V4.17285H55.9343ZM55.9343 9.19045V22.4001H51.675V9.19045H55.9343Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1045 22.4001V4.17285H37.7646L44.2036 15.6929L44.0032 4.17285H48.513V22.4001H43.9781L37.464 10.7009L37.5892 22.4001H33.1045Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4885,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.013cf8c9e7f81faa04178f84436df46c.svg";
export { ForwardRef as ReactComponent };